module.exports = __webpack_public_path__ + "static/webcomponents-7e2bdd0792f33065f5ae16856980f9be.png";